import type { RendererProps } from '@backstage/plugin-home-react';
import { Card, CardBody, CardHeader, Text } from '@backstage/ui';

// CardExtension draws a material-ui InfoCard unless a Renderer is supplied.
// Widgets pass this one via `componentProps` to keep the chrome on @backstage/ui.
export const HomeCard = ({ title, Content, ...rest }: RendererProps) => (
  <Card className="primary-home-card">
    {title && (
      <CardHeader>
        <Text variant="title-x-small">{title}</Text>
      </CardHeader>
    )}
    <CardBody className="primary-home-card-body">
      <Content {...rest} />
    </CardBody>
  </Card>
);
